<script>

</script>

<template>
  <div class="main-content">
    <router-view/>
  </div>
</template>

<style scoped>

</style>